var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.VueEditor,{staticClass:"ui-widget-content",attrs:{"id":_setup.props.id,"value":_vm.value,"use-custom-image-handler":true,"editor-toolbar":_setup.customToolbar,"editor-options":_setup.editorOptions},on:{"input":_setup.updateText,"image-added":_setup.handleImageAdded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }